import type { ReactNode } from "react";
import type { CautionLevel } from "@tebiki/shared";
import { Icon } from "./Icon.js";

type Variant = "info" | "warn" | "danger" | "ai";

const ICON: Record<Variant, ReactNode> = {
  info: <Icon name="info" />,
  warn: <Icon name="warning" />,
  danger: <Icon name="close" />,
  ai: <Icon name="ai-review" />,
};

interface BannerProps {
  variant?: Variant;
  icon?: ReactNode;
  children?: ReactNode;
  className?: string;
}

/** Map the shared CautionLevel onto a banner variant. */
export function cautionVariant(level: CautionLevel): Variant {
  return level === "danger" ? "danger" : level === "warning" ? "warn" : "info";
}

export function Banner({ variant = "info", icon, children, className }: BannerProps) {
  // "ai" reuses the warn surface but with the ✦ glyph (matches the ui/ prototypes).
  const surfaceVariant = variant === "ai" ? "warn" : variant;
  const cls = ["banner", `banner--${surfaceVariant}`, "jp", className].filter(Boolean).join(" ");
  return (
    <div className={cls}>
      <span className="b-ico" aria-hidden="true">
        {icon ?? ICON[variant]}
      </span>
      <span className="grow">{children}</span>
    </div>
  );
}
